import { Outlet } from "react-router-dom";

const MinimumWagesLayout = () => {
  return <Outlet />;
};

export default MinimumWagesLayout;
